var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { useMergeRefs } from '@floating-ui/react';
import { useEffect, useRef } from 'react';
import { C } from '#integrations';
import { safeHidePopover, safeShowPopover } from '#services';
import { ComboboxTestIdFactory } from '../../interactions';
import { ComboboxGroup } from '../ComboboxGroup';
import { ComboboxOption } from '../ComboboxOption';
import styles from './ComboboxList.module.css';
const MAX_LIST_HEIGHT_CLASS_MAP = {
    m: styles.ListSizeM,
};
export const ComboboxList = ({ ariaLabel, comboboxListPositioningTargetPropsRef, currentOptionIndex, currentRef, currentStyledOptionIndex, 'data-testid': testId, filteredOptions, hasOptionGroups, hasOptions, id, innerValue, isExpanded, isMultiselect, keepInputFocus, labelId, listboxId, listClassName, maxListHeight, options, renderOption, select, style, }) => {
    _react_refresh_temp_2();
    const maxListHeightClassName = MAX_LIST_HEIGHT_CLASS_MAP[maxListHeight];
    const containerRef = useRef(null);
    const listBoxRef = useRef(null);
    const comboboxListRef = useMergeRefs([
        comboboxListPositioningTargetPropsRef,
        containerRef,
    ]);
    useEffect(() => {
        if (isExpanded) {
            safeShowPopover(containerRef.current);
            if (listBoxRef.current) {
                listBoxRef.current.scrollTop = 0;
            }
        }
        else {
            safeHidePopover(containerRef.current);
        }
    }, [isExpanded]);
    return (_jsx("div", { className: C(styles.Container, hasOptions && maxListHeightClassName, listClassName), popover: "manual", ref: comboboxListRef, style: style, children: _jsx("ol", { ...(ariaLabel
                ? { 'aria-label': ariaLabel }
                : labelId && { 'aria-labelledby': labelId }), "aria-multiselectable": isMultiselect, className: styles.Listbox, "data-testid": ComboboxTestIdFactory.getComboboxListboxTestId(testId), id: listboxId, ref: listBoxRef, role: "listbox", children: hasOptionGroups
                ? options
                    .filter((og) => og.options.some((o) => filteredOptions.find((fo) => fo.id === o.id)))
                    .map((option, groupIndex) => {
                    return (_jsx(ComboboxGroup, { allOptions: filteredOptions, comboboxId: id, currentOptionIndex: currentOptionIndex, currentRef: currentRef, currentStyledOptionIndex: currentStyledOptionIndex, "data-testid": testId, groupIndex: groupIndex, groupOptions: option.options, id: `${listboxId}-group-${groupIndex}`, innerValue: innerValue, isMultiselect: isMultiselect, keepInputFocus: keepInputFocus, label: option.label, renderOption: renderOption, select: select }, option.label));
                })
                : filteredOptions.map((option, optionIndex) => {
                    const isSelected = isMultiselect
                        ? innerValue?.includes(option.id)
                        : innerValue === option.id;
                    const isCurrent = optionIndex === currentOptionIndex;
                    const isStyledCurrent = isMultiselect
                        ? optionIndex === currentStyledOptionIndex
                        : optionIndex === currentOptionIndex;
                    return (_jsx(ComboboxOption, { comboboxId: id, "data-testid": testId, isCurrent: isCurrent, isMultiselect: isMultiselect, isSelected: isSelected, isStyledCurrent: isStyledCurrent, keepInputFocus: keepInputFocus, option: option, optionIndex: optionIndex, ref: currentRef, renderOption: renderOption, select: select }, option.id));
                }) }) }));
};
_react_refresh_temp_1 = ComboboxList;
$RefreshReg$(_react_refresh_temp_1, "ComboboxList");
_react_refresh_temp_2(ComboboxList, "R06KqZn1vJwxC1j72XMR/bGqimA=", false, () => [useMergeRefs]);
